import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Redirect to /pending whenever the backend signals an expired/disabled
// account. This keeps expired trial users from seeing broken dashboards.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (
      err?.response?.status === 403 &&
      typeof detail === "string" &&
      detail === "account_pending_approval" &&
      typeof window !== "undefined" &&
      !window.location.pathname.startsWith("/pending")
    ) {
      window.location.replace("/pending");
    }
    return Promise.reject(err);
  }
);
